import styled from "styled-components"

const backToTopStatus = ({ pageScrolled }) => (pageScrolled ? "block" : "none")

export const BackToTop = styled.div`
  display: ${backToTopStatus};
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 99;
  background: #f51767;
  color: #fff;

  cursor: pointer;
  padding: 13px 15px;
  border-radius: 3px;
  font-size: 18px;
  box-shadow: rgba(19, 15, 235, 0.31) 1px 2px 20px;

  & path {
    stroke: #fff;
  }
`

// follow same text styling as on blog post (blog-post.styles.js)
export const CheatsheetContainer = styled.div`
  grid-column: 3/11;

  .gatsby-highlight {
    max-width: none;
  }

  /* a wrapped div around the table to ensure the table is responsive */
  .scroll-table {
    overflow-x: auto;
  }
  table {
    margin-bottom: 25px;
  }
  /* custom container around iframe to ensure the video is responsive */
  .custom-container {
    margin-bottom: 25px;
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  /* make sure GIF video tag is responsive and remove black video outline */
  video {
    display: block;
    margin: 0 auto;
    width: 90%;
    height: auto;
    ::-webkit-media-controls-enclosure {
      border: 1px solid #fff;
    }
  }

  a {
    color: ${({ theme: { colors } }) => colors.hyperLinkPink};
  }

  /* we want main heading links to be black */
  h2 > a,
  h3 > a,
  h4 > a {
    color: ${({ theme: { colors } }) => colors.black};
  }

  /* adding margin around blog post images so that we don't need to add line break */
  img {
    width: 100%;
    max-width: fit-content;
    height: auto;
    margin: 55px 0;
    @media screen and (max-width: 760px) {
      margin: 35px 0;
    }
  }

  h2,
  h3,
  h4,
  a {
    scroll-margin-top: 90px;
  }
  p {
    margin: 4px 0 20px 0;
    font-size: 20px;
  }
  h1 {
    ${({ theme: { typography } }) => typography.desktop.h1};
    text-align: left;
    margin-bottom: 20px;
  }
  h2 {
    ${({ theme: { typography } }) => typography.desktop.h2};
    border-bottom: 0.5px solid #f51767;
    padding-bottom: 30px;
    margin: 60px 0 30px;
  }
  h3 {
    ${({ theme: { typography } }) => typography.desktop.h3};
    margin: 40px 0 25px;
  }
  h4 {
    ${({ theme: { typography } }) => typography.desktop.h4};
    margin: 40px 0 25px;
  }

  li {
    line-height: 1.8em;
    margin-bottom: 5px;
    &::marker {
      color: ${({ theme: { colors } }) => colors.hyperLinkPink};
      font-weight: 700;
    }
  }

  ol,
  ul {
    /* To align the list with the text */
    padding-left: 25px;
    font-size: 20px;
  }
  ol > li,
  ul > li {
    padding-left: 5px;
  }

  /* list inside ToC don't need to show bullet points ToC links should be darkGrey */
  &.toc-container {
    li {
      list-style-type: none;
    }

    li > a {
      color: ${({ theme: { colors } }) => colors.darkGrey};
    }
    ul {
      margin-top: 0;
    }
    h3 {
      margin-bottom: 15px;
      font-size: 20px;
      line-height: 30px;
      color: ${({ theme: { colors } }) => colors.darkGrey};
    }
    h3 > a {
      color: ${({ theme: { colors } }) => colors.darkGrey};
    }
  }

  blockquote {
    border-left: 3px solid ${({ theme: { colors } }) => colors.accentPink};
    margin-left: 3px;
    p {
      color: ${({ theme: { colors } }) => colors.accentPink};
    }
  }

  /* Styles the code block in a blog post */
  pre {
    background: rgba(19, 15, 235, 0.03);
    /* box-shadow: 2px 4px 40px rgba(19, 15, 235, 0.1); */
    color: #2e2e2e;
    font-family: Courier New, Courier, monospace;
    padding: 15px 30px;
    border-radius: 5px;
    overflow-x: scroll;
  }
  pre code {
    font-family: Courier New, Courier, monospace;
  }
  @media screen and (max-width: 1000px) {
    grid-column: 2/6;
  }
  @media screen and (max-width: 760px) {
    grid-column: 1/-1;
    h1 {
      ${({ theme: { typography } }) => typography.mobile.h1};
    }
    h2 {
      ${({ theme: { typography } }) => typography.mobile.h2};
      margin: 40px 0 15px;
    }
    h3 {
      ${({ theme: { typography } }) => typography.mobile.h3};
      margin: 25px 0;
    }
    h4 {
      ${({ theme: { typography } }) => typography.mobile.h4};
    }
    h1,
    h2,
    h3,
    h4 {
      margin-bottom: 15px;
    }

    p,
    li {
      font-size: 18px;
    }
  }
`
